// extracted by mini-css-extract-plugin
export default {"breakpoint-tablet":"only screen and (min-width: 768px)","fallback":"asideList_fallback__o-e9o","list":"asideList_list__YlG8w","scroll":"asideList_scroll__7hrUS"};